// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 广告页留资（匿名） POST /v3/auth/ad/mobile */
export async function v3AuthAdMobileUsingPOST(
  body: API.AdMobileV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/v3/auth/ad/mobile', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 注销账号 POST /v3/auth/cancel */
export async function v3AuthCancelUsingPOST(
  body: API.CancelV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/v3/auth/cancel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 发送短信验证码 POST /v3/auth/code/sms */
export async function v3AuthCodeSmsUsingPOST(
  body: API.SendCodeV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSendSmsResp>('/v3/auth/code/sms', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 发送语音验证码 POST /v3/auth/code/voice */
export async function v3AuthCodeVoiceUsingPOST(
  body: API.SendCodeV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSendSmsResp>('/v3/auth/code/voice', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Apple登录 POST /v3/auth/login/apple */
export async function v3AuthLoginAppleUsingPOST(
  body: API.AppleLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/apple', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 手机号+验证码登录 POST /v3/auth/login/mobile */
export async function v3AuthLoginMobileUsingPOST(
  body: API.MobileLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/mobile', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 运营商一键登录 POST /v3/auth/login/one-key */
export async function v3AuthLoginOneKeyUsingPOST(
  body: API.OneKeyLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/one-key', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 访问密钥登录 POST /v3/auth/login/secret */
export async function v3AuthLoginSecretUsingPOST(
  body: API.SecretLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/secret', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 冷启动恢复会话 POST /v3/auth/login/session */
export async function v3AuthLoginSessionUsingPOST(
  body: API.SessionLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultSessionLoginV3Resp>('/v3/auth/login/session', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App微信登录 POST /v3/auth/login/wx-app */
export async function v3AuthLoginWxAppUsingPOST(
  body: API.WxAppLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/wx-app', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 微信小程序登录 POST /v3/auth/login/wx-ma */
export async function v3AuthLoginWxMaUsingPOST(
  body: API.WxMaLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/wx-ma', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 微信公众号OAuth登录 POST /v3/auth/login/wx-oa */
export async function v3AuthLoginWxOaUsingPOST(
  body: API.WxOaLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/wx-oa', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** PC网页微信登录 POST /v3/auth/login/wx-pc */
export async function v3AuthLoginWxPcUsingPOST(
  body: API.WxPcLoginV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/login/wx-pc', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 退出登录 POST /v3/auth/logout */
export async function v3AuthLogoutUsingPOST(
  body: API.LogoutV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/v3/auth/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 绑定手机号 POST /v3/auth/mobile/bind */
export async function v3AuthMobileBindUsingPOST(
  body: API.BindMobileV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/v3/auth/mobile/bind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 更换手机号 POST /v3/auth/mobile/change */
export async function v3AuthMobileChangeUsingPOST(
  body: API.ChangeMobileV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/v3/auth/mobile/change', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询换绑次数/额度 GET /v3/auth/mobile/change/quota */
export async function v3AuthMobileChangeQuotaUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultVoid>('/v3/auth/mobile/change/quota', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取一键登录证书 GET /v3/auth/one-key/certificate */
export async function v3AuthOneKeyCertificateUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultOneKeyLoginCertificate>('/v3/auth/one-key/certificate', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Apple注册 POST /v3/auth/register/apple */
export async function v3AuthRegisterAppleUsingPOST(
  body: API.AppleRegisterV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/register/apple', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App微信注册（已授权用户可凭登录态注册） POST /v3/auth/register/wx-app */
export async function v3AuthRegisterWxAppUsingPOST(
  body: API.WxAppRegisterV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/register/wx-app', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 微信小程序注册 POST /v3/auth/register/wx-ma */
export async function v3AuthRegisterWxMaUsingPOST(
  body: API.WxMaRegisterV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/register/wx-ma', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 微信公众号/已授权用户注册（H5、PC） POST /v3/auth/register/wx-oa */
export async function v3AuthRegisterWxOaUsingPOST(
  body: API.WxOaRegisterV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/register/wx-oa', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** PC设备占用检查 GET /v3/auth/session/check */
export async function v3AuthSessionCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.v3AuthSessionCheckUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCheckLoginStatusResp>('/v3/auth/session/check', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 刷新Token POST /v3/auth/token/refresh */
export async function v3AuthTokenRefreshUsingPOST(
  body: API.RefreshTokenV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultRefreshTokenV3Resp>('/v3/auth/token/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 生成微信授权跳转链接 GET /v3/auth/wx/authorize-url */
export async function v3AuthWxAuthorizeUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.v3AuthWxAuthorizeUrlUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/v3/auth/wx/authorize-url', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 绑定微信 POST /v3/auth/wx/bind */
export async function v3AuthWxBindUsingPOST(
  body: API.WxBindV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/wx/bind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 微信授权回调 GET /v3/auth/wx/callback */
export async function v3AuthWxCallbackUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.v3AuthWxCallbackUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<any>('/v3/auth/wx/callback', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 刷新微信资料 POST /v3/auth/wx/info */
export async function v3AuthWxInfoUsingPOST(
  body: API.WxInfoV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultWxBindInfo>('/v3/auth/wx/info', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询当前用户微信信息 GET /v3/auth/wx/me */
export async function v3AuthWxMeUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultWxBindInfo>('/v3/auth/wx/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 解绑微信 POST /v3/auth/wx/unbind */
export async function v3AuthWxUnbindUsingPOST(
  body: API.WxUnbindV3Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAuthTokenResp>('/v3/auth/wx/unbind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
